import { render } from "./FavoriteOperatorCard.vue?vue&type=template&id=f88b1954&scoped=true"
import script from "./FavoriteOperatorCard.vue?vue&type=script&lang=js"
export * from "./FavoriteOperatorCard.vue?vue&type=script&lang=js"

import "./FavoriteOperatorCard.vue?vue&type=style&index=0&id=f88b1954&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f88b1954"

export default script